var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Icon } from '../../utils/icon-utils.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { Translate } from '../../utils/translate.js';
let ComboBoxComponent = class ComboBoxComponent extends GGOBaseComponent {
    static { this.properties = {
        // label: { type: String },
        values: { type: Array },
        // placeHolder: { type: String },
        selectedValue: { type: Object },
        isOpen: { type: Boolean },
        // object && objectProperty are used to bind the combobox to an object property
        object: { type: Object }, // optional
        objectProperty: { type: String }, // optional
        separatorIndex: { type: Number },
    }; }
    //placeholder = 'Select an option';
    //selected = '';
    static get styles() {
        return [
            ...super.styles,
            css `
        .slds-combobox__input>span {
          font-size: .85rem;
        }
        .slds-combobox__input {
          cursor: pointer;
        }
        .slds-combobox__input:hover {
          border: solid .5px #1b96ff;
        }
        .slds-listbox__item:hover {
          color: #0176D3;
        }
        .slds-dropdown {
          margin-top: 1px;
        }
        `,
        ];
    }
    constructor() {
        super();
        this.placeHolder = `${Translate.get('combobox_placeholder')}`;
        this.handleOutsideClick = (e) => {
            if (!this.shadowRoot?.contains(e.target)) {
                this.isOpen = false;
            }
        };
        this.isOpen = false;
    }
    // getLabelTemplate() {
    //   return this.label ? html` <label class="slds-form-element__label" for="combobox" id="combobox-label">${this.label}</label> ` : nothing;
    // }
    onOptionClicked(e) {
        this.isOpen = false;
        const selectedLabel = e.currentTarget.dataset.value;
        this.selectedValue = this.values.find((value) => this.getLabel(value) === selectedLabel) ?? this.values[0];
        if (this.object && this.objectProperty) {
            this.object[this.objectProperty] = this.selectedValue;
        }
        this.dispatchEvent(new CustomEvent('changed', { detail: this.selectedValue }));
        this.requestUpdate();
    }
    getLabel(cboption) {
        let label = '';
        if (typeof cboption === 'string') {
            label = cboption;
        }
        else if (typeof cboption === 'object') {
            if (cboption.alias)
                label = cboption.alias;
            else if (cboption.label)
                label = cboption.label;
            else if (cboption.name)
                label = cboption.name;
            else
                throw new Error('Combobox option must have a label or name property');
        }
        return label;
    }
    /**
     * Try various ways to determine if the option is selected
     * @param cboption
     * @returns
     */
    isSelected(cboption) {
        //if (this.selectedValue === undefined) return false;
        if (typeof cboption === 'object' && typeof this.selectedValue === 'string') {
            if (cboption.id)
                return cboption.id === this.selectedValue;
            if (cboption.name)
                return cboption.name === this.selectedValue;
        }
        if (typeof cboption === 'object' && typeof this.selectedValue === 'object') {
            if (cboption.id)
                return cboption.id === this.selectedValue.id;
            if (cboption.name)
                return cboption.name === this.selectedValue.name;
        }
        return cboption === this.selectedValue;
    }
    toggleDropdown() {
        this.isOpen = !this.isOpen;
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('click', this.handleOutsideClick);
    }
    disconnectedCallback() {
        document.removeEventListener('click', this.handleOutsideClick);
        super.disconnectedCallback();
    }
    resetInput() {
        this.selectedValue = undefined;
        if (this.object && this.objectProperty) {
            this.object[this.objectProperty] = null;
        }
        this.dispatchEvent(new CustomEvent('changed', { detail: null }));
        this.requestUpdate("selectedValue");
    }
    getOptionTemplate(cboption) {
        const is_selected = this.isSelected(cboption);
        const selectedIcon = is_selected
            ? html `
          <span class="slds-icon_container slds-icon-utility-check slds-current-color">
            ${Icon.getSVGIconTag({
                icon: 'check',
                sprite: 'utility',
                classes: ['slds-icon', 'slds-icon_x-small'],
            })}
          </span>
        `
            : nothing;
        const is_selected_class = is_selected ? 'slds-is-selected' : '';
        let label = this.getLabel(cboption);
        return html `
      <li role="presentation" class="slds-listbox__item" @click=${this.onOptionClicked} data-value="${this.getLabel(cboption)}">
        <div id="option724" class="slds-media slds-listbox__option slds-listbox__option_plain slds-media_small ${is_selected_class}" role="option">
          <span class="slds-media__figure slds-listbox__option-icon">${selectedIcon}</span>
          <span class="slds-media__body">
            <span class="slds-truncate" title="${label}">${label}</span>
          </span>
        </div>
      </li>
    `;
    }
    render() {
        if (this.object && this.objectProperty) {
            this.selectedValue = this.object[this.objectProperty];
        }
        // <div class="slds-form-element">${this.getLabelTemplate()}</div> 
        return html `
      <div class="slds-form-element__control">
        <div class="slds-combobox_container">
          <div class="slds-combobox slds-dropdown-trigger slds-dropdown-trigger_undefined">
            <div class="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right" role="none">
             <div
              role="combobox"
              tabindex="0"
              class="slds-input_faux slds-combobox__input"
              aria-labelledby="combobox-label"
              id="combobox-selected-value"
              aria-controls="listbox-id"
              aria-expanded="${this.isOpen}"
              aria-haspopup="listbox"
              @click=${(e) => { e.stopPropagation(); this.toggleDropdown(); }}
            >
                <span class="slds-truncate" id="combobox-value">${this.selectedValue ? this.getLabel(this.selectedValue) : this.placeHolder}</span>
              </div>
              ${this.selectedValue ? html `
              <button @click=${(e) => { e.stopPropagation(); this.resetInput(); }} class="slds-button slds-button_icon slds-input__icon slds-input__icon_right" title="Clear the text input">
                ${Icon.getSVGIconTag({
            icon: 'close',
            sprite: 'utility',
            classes: ['slds-icon', 'slds-icon_x-small', 'slds-icon-text-default'],
        })}
                <span class="slds-assistive-text">Clear the text input</span>
              </button>
                ` : html `
              <span class="slds-icon_container slds-icon-utility-chevrondown slds-input__icon slds-input__icon_right">
                ${Icon.getSVGIconTag({
            icon: 'chevrondown',
            sprite: 'utility',
            classes: ['slds-icon', 'slds-icon_x-small', 'slds-icon-text-default'],
        })}
              </span>
                `}
            </div>
            ${this.isOpen ? html `
              <div
                id="listbox-id"
                class="slds-dropdown slds-dropdown_length-5 slds-dropdown_fluid"
                role="listbox"
                tabindex="0"
              >
                <ul class="slds-listbox slds-listbox_vertical" role="presentation">
                  ${this.values?.map((value, idx) => html `
                    ${this.getOptionTemplate(value)}
                    ${(idx === this.separatorIndex) ? html `<li class="slds-listbox__item"><div style="border-top:1px solid #e5e5e5;margin:4px 0;"></div></li>` : nothing}
                  `)}
                </ul>
              </div>
            ` : nothing}
          </div>
        </div>
      </div>
    `;
    }
};
__decorate([
    property()
], ComboBoxComponent.prototype, "placeHolder", void 0);
__decorate([
    property({ type: Number })
], ComboBoxComponent.prototype, "separatorIndex", void 0);
ComboBoxComponent = __decorate([
    customElement('ggo-combobox')
], ComboBoxComponent);
export { ComboBoxComponent };
